import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


/*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
 20200311 ishida
 ※id追加：28～
 ・Bタイプlightグレード新規追加
 ・Bタイプ既存グレードのサイズ追加
-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

export default new Vuex.Store({
  state: {
    menu: false,
    currentSection: '',
    isThreshold: 0.8,
    catalogList: [
      {
        id: 1,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: true,
        type: ['W'],
        grade: ['Safety'],
        size: ['1216'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/w_safety_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドベージュ',
        wallColor: 'カルドウッド',
        surroundingWall: 'カルドウッド',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'アクリル浴槽',
        bathtubColor: 'クリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF850　壁付水栓（サーモ）',
        showerType: 'ワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡280x1150',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'SUS手摺L1000スライドフック付',
        sideHandrail: 'SUS手摺L800',
        doorHandrail: 'SUS手摺L800',
        towel: 'タオルリング',
        rackType: 'クリアオープン棚W180メッキ3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: 'シットレスト有・シャワー温浴チェア有',
        basicPrice: '¥ 1,605,000',
        optionPrice: '¥ 65,000',
        totalPrice: '¥ 1,670,000'
      },
      {
        id: 2,
        recommendIndex: 20,
        modal: false,
        recommend: true,
        hasPackage: true,
        type: ['W'],
        grade: ['Safety'],
        size: ['1616', '1618'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/w_safety_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '/images/recommend_2.jpg',
        recommendImageMin: '/images/recommend_tb_2.jpg',
        floorColor: 'サンドホワイト',
        wallColor: 'キュービーホワイト',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: 'ヒクトーレW1200',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF850　壁付水栓（サーモ）',
        showerType: 'ワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡280x1150',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'SUS手摺L1000スライドフック付',
        sideHandrail: 'SUS手摺L800',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: '無',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: 'シットレスト有・シャワー温浴チェア有',
        basicSize: '1616',
        basicPrice: '¥ 1,675,000',
        optionPrice: '¥ 110,000',
        totalPrice: '¥ 1,785,000',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,807,000',
        anotherOptionPrice: '¥ 110,000',
        anotherTotalPrice: '¥ 1,917,000'
      },
      // {
      //   id: 3,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: true,
      //   type: ['W'],
      //   grade: ['Safety'],
      //   size: ['1618'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: false,
      //   thumbnail: '/images/w_safety_1618.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'サンドホワイト',
      //   wallColor: 'キュービーホワイト',
      //   surroundingWall: 'グロスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-24',
      //   doorType: 'ヒクトーレW1200',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'ウェイビー浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアホワイト',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ホワイト',
      //   waterPanel: 'KF850壁付水栓（サーモ）',
      //   showerType: 'ワンストップｅシャワー（メタル）',
      //   storageType: 'スクエアミラー',
      //   mirrorType: '鏡280x1150',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'SUS手摺L1000スライドフック付',
      //   sideHandrail: 'SUS手摺L800',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ3段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'シットレスト有・シャワー温浴チェア有',
      //   basicPrice: '¥ 1,542,000',
      //   optionPrice: '¥ 110,000',
      //   totalPrice: '¥ 1,652,000'
      // },
      {
        id: 4,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: true,
        type: ['W'],
        grade: ['Easy'],
        size: ['1216'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/w_easy_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドホワイト',
        wallColor: 'キュービーアクア',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'アクリル浴槽',
        bathtubColor: 'クリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: '無',
        waterPanel: 'トップシャワー',
        showerType: '4Wayハンドシャワー',
        storageType: '無',
        mirrorType: '無',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: '',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'SUSワイヤーラック3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicPrice: '¥ 1,463,000',
        optionPrice: '¥ 0',
        totalPrice: '¥ 1,463,000'
      },
      {
        id: 5,
        recommendIndex: 30,
        modal: false,
        recommend: true,
        hasPackage: true,
        type: ['W'],
        grade: ['Easy'],
        size: ['1616', '1618'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/w_easy_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '/images/recommend_5.jpg',
        recommendImageMin: '/images/recommend_tb_5.jpg',
        floorColor: 'サンドホワイト',
        wallColor: 'ブロッコブラック',
        surroundingWall: 'キュービーホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-24',
        doorType: 'ＢＭ開戸',
        doorMaterial: 'トウメイ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアブラックツートン',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: '無',
        waterPanel: 'トップシャワー',
        showerType: '4Wayハンドシャワー',
        storageType: '無',
        mirrorType: '無',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: '',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'SUSワイヤーラック3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicSize: '1616',
        basicPrice: '¥ 1,533,000',
        optionPrice: '¥ 315,000',
        totalPrice: '¥ 1,848,000',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,665,000',
        anotherOptionPrice: '¥ 315,000',
        anotherTotalPrice: '¥ 1,980,000'
      },
      // {
      //   id: 6,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: true,
      //   type: ['W'],
      //   grade: ['Easy'],
      //   size: ['1618'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: false,
      //   thumbnail: '/images/w_easy_1618.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'サンドホワイト',
      //   wallColor: 'ブロッコブラック',
      //   surroundingWall: 'グロスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-24',
      //   doorType: 'ＢＭ開戸',
      //   doorMaterial: 'トウメイ',
      //   bathtubShape: 'ウェイビー浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアブラックツートン',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: '無',
      //   waterPanel: 'トップシャワー',
      //   showerType: '4Wayハンドシャワー',
      //   storageType: '無',
      //   mirrorType: '無',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'SUS手摺L1000スライドフック付',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'SUSワイヤーラック3段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: '',
      //   basicPrice: '¥ 1,400,000',
      //   optionPrice: '¥ 298,000',
      //   totalPrice: '¥ 1,698,000'
      // },
      {
        id: 7,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: true,
        type: ['W'],
        grade: ['Eco'],
        size: ['1216'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/w_eco_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'アストラブラック',
        wallColor: 'ソルティオニックス',
        surroundingWall: 'ソルティオニックス',
        ceilingColor: 'ホワイト',
        ventilation: '換気暖房乾燥機BS261H-CX-SH(200V)除菌',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'アクリル浴槽',
        bathtubColor: 'キラットブラックツートン',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ブラック',
        counterColor: 'ホワイト',
        waterPanel: 'KF3070 壁付タッチ水栓',
        showerType: '3Wayワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡280x1150',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'SUS手摺L1000スライドフック付',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicPrice: '¥ 1,654,500',
        optionPrice: '¥ 70,000',
        totalPrice: '¥ 1,724,500'
      },
      {
        id: 8,
        recommendIndex: 40,
        modal: false,
        recommend: true,
        hasPackage: true,
        type: ['W'],
        grade: ['Eco'],
        size: ['1616', '1618'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/w_eco_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '/images/recommend_8.jpg',
        recommendImageMin: '/images/recommend_tb_8.jpg',
        floorColor: 'サンドベージュ',
        wallColor: 'ブロッコベージュ',
        surroundingWall: 'キュービーホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '24乾燥機BS-261CX(200V)除菌',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアオルジュツートン',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF3070 壁付タッチ水栓',
        showerType: '3Wayワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡280x1150',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'SUS手摺L1000スライドフック付',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicSize: '1616',
        basicPrice: '¥ 1,724,500',
        optionPrice: '¥ 70,000',
        totalPrice: '¥ 1,794,500',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,856,500',
        anotherOptionPrice: '¥ 70,000',
        anotherTotalPrice: '¥ 1,926,500'
      },
      // {
      //   id: 9,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: true,
      //   type: ['W'],
      //   grade: ['Eco'],
      //   size: ['1618'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: false,
      //   thumbnail: '/images/w_eco_1618.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'サンドベージュ',
      //   wallColor: 'ブロッコベージュ',
      //   surroundingWall: 'キュービーホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '24乾燥機BS-261CX(200V)除菌',
      //   doorType: '折戸',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'ウェイビー浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアオルジュツートン',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ホワイト',
      //   waterPanel: 'KF3070 壁付タッチ水栓',
      //   showerType: '3Wayワンストップｅシャワー（メタル）',
      //   storageType: 'スクエアミラー',
      //   mirrorType: '鏡280x1150',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'SUS手摺L1000スライドフック付',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ3段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: '',
      //   basicPrice: '¥ 1,591,500',
      //   optionPrice: '¥ 30,000',
      //   totalPrice: '¥ 1,621,500'
      // },
      {
        id: 10,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['W'],
        grade: ['Standard'],
        size: ['1216'],
        gradeType: 'Standard',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/w_standard_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドホワイト',
        wallColor: 'ブロッコブラック',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '開き戸',
        doorMaterial: 'トウメイ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'アクリル浴槽',
        bathtubColor: 'キラットブラックツートン',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ブラック',
        counterColor: 'ブラック',
        waterPanel: 'KF850　壁付水栓（サーモ）',
        showerType: 'ワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡280x1150',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: ' SUS手摺L1000スライドフック付',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicPrice: '¥ 1,403,000',
        optionPrice: '¥ 48,000',
        totalPrice: '¥ 1,451,000'
      },
      {
        id: 11,
        recommendIndex: 10,
        modal: false,
        recommend: true,
        hasPackage: false,
        type: ['W'],
        grade: ['Standard'],
        size: ['1616', '1618'],
        gradeType: 'Standard',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/w_standard_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '/images/recommend_11.jpg',
        recommendImageMin: '/images/recommend_tb_11.jpg',
        floorColor: 'サンドホワイト',
        wallColor: 'キュービーアクア',
        surroundingWall: 'キュービーホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: 'ＢＭ開戸',
        doorMaterial: 'トウメイ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアオーシャンツートン',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF850　壁付水栓（サーモ）',
        showerType: 'ワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡280×1546＋LED間接照明',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'SUS手摺L1000スライドフック付',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ3段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicSize: '1616',
        basicPrice: '¥ 1,473,000',
        optionPrice: '¥ 475,000',
        totalPrice: '¥ 1,948,000',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,605,000',
        anotherOptionPrice: '¥ 475,000',
        anotherTotalPrice: '¥ 2,080,000'
      },
      // {
      //   id: 12,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: false,
      //   type: ['W'],
      //   grade: ['Standard'],
      //   size: ['1618'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: '*価格は戸建仕様',
      //   thumbnail: '/images/w_standard_1618.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'サンドホワイト',
      //   wallColor: 'キュービーアクア',
      //   surroundingWall: 'キュービーホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-24',
      //   doorType: 'ＢＭ開戸',
      //   doorMaterial: 'トウメイ',
      //   bathtubShape: 'ウェイビー浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアオーシャンツートン',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ホワイト',
      //   waterPanel: 'KF850&nbsp;壁付水栓（サーモ）',
      //   showerType: 'ワンストップｅシャワー（メタル）',
      //   storageType: 'スクエアミラー',
      //   mirrorType: '鏡280x1150+LED間接照明',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'SUS手摺L1000スライドフック付',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ3段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: '',
      //   basicPrice: '¥ 1,340,000',
      //   optionPrice: '¥ 475,000',
      //   totalPrice: '¥ 1,815,000'
      // },
      {
        id: 13,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['W'],
        grade: ['Simple'],
        size: ['1216'],
        gradeType: 'Simple',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/w_simple_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドベージュ',
        wallColor: 'マローネウッド',
        surroundingWall: 'ミハスホワイト',
        ceilingColor: 'マローネウッド',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'アクリル浴槽',
        bathtubColor: 'クリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓（サーモ）',
        showerType: 'ワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡300x900',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱスライドフック付',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: 'お掃除収納',
        basicPrice: '¥ 1,223,000',
        optionPrice: '¥ 38,000',
        totalPrice: '¥ 1,261,000'
      },
      {
        id: 14,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['W'],
        grade: ['Simple'],
        size: ['1616', '1618'],
        gradeType: 'Simple',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/w_simple_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'ウッディブラウン',
        wallColor: 'キュービーホワイト',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '開き戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'ウェイビー浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓(サーモ)',
        showerType: 'ワンストップｅシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: '鏡300x900',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱスライドフック付',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicSize: '1616',
        basicPrice: '¥ 1,293,000',
        optionPrice: '¥ 128,000',
        totalPrice: '¥ 1,421,000',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,425,000',
        anotherOptionPrice: '¥ 128,000',
        anotherTotalPrice: '¥ 1,553,000'
      },
      // {
      //   id: 15,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: false,
      //   type: ['W'],
      //   grade: ['Simple'],
      //   size: ['1618'],
      //   gradeType: 'Simple',
      //   noteDetachedOrComplex: '*価格は戸建仕様',
      //   thumbnail: '/images/w_simple_1618.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'サンドホワイト',
      //   wallColor: 'カルドウッド',
      //   surroundingWall: 'ミハスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-24',
      //   doorType: '折戸',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'ウェイビー浴槽',
      //   bathtubMaterial: 'アクリル浴槽',
      //   bathtubColor: 'クリアホワイト',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ホワイト',
      //   waterPanel: 'KF800&nbsp;壁付水栓（サーモ）',
      //   showerType: 'ワンストップｅシャワー（メタル）',
      //   storageType: 'スクエアミラー',
      //   mirrorType: '鏡300x900',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱスライドフック付',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,160,000',
      //   optionPrice: '¥ 8,000',
      //   totalPrice: '¥ 1,168,000'
      // },
      {
        id: 16,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: true,
        type: ['B'],
        grade: ['Eco'],
        size: ['1216'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/b_eco_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドベージュ',
        wallColor: 'ブロッコベージュ',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気暖房乾燥機BS261H-CX-SH(200V)除菌',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'アークスクエア浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF3070 壁付タッチ水栓',
        showerType: '3Wayワンストップeシャワー（メタル）',
        storageType: 'ワイドミラー',
        mirrorType: 'ワイドミラー',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '巻きフタ',
        frame: '窓額縁D200 1300x1000 OW',
        other: 'お掃除収納',
        basicPrice: '¥ 1,500,500',
        optionPrice: '¥ 8,000',
        totalPrice: '¥ 1,508,500'
      },
      {
        id: 17,
        recommendIndex: 60,
        modal: false,
        recommend: true,
        hasPackage: true,
        type: ['B'],
        grade: ['Eco'],
        size: ['1616', '1618', '1620'],
        gradeType: 'Standard',
        noteDetachedOrComplex: false,
        thumbnail: '/images/b_eco_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '/images/recommend_17.jpg',
        recommendImageMin: '/images/recommend_tb_17.jpg',
        floorColor: 'サンドベージュ',
        wallColor: 'マローネウッド',
        surroundingWall: 'ミハスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気暖房乾燥機BS261H-CX-SH(200V)除菌',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'スマートスクエア浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアベージュ',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ファインホワイト',
        waterPanel: 'KF3070 壁付タッチ水栓',
        showerType: '3Wayワンストップeシャワー（メタル）',
        storageType: 'ワイドミラー',
        mirrorType: 'ワイドミラー',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '巻きフタ',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicSize: '1616',
        basicPrice: '¥ 1,570,500',
        optionPrice: '¥ 0',
        totalPrice: '¥ 1,570,500',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,702,500',
        anotherOptionPrice: '¥ 0',
        anotherTotalPrice: '¥ 1,702,500',
        anotherSize2: '1620',
        anotherBasicPrice2: '¥ 1,802,500',
        anotherOptionPrice2: '¥ 0',
        anotherTotalPrice2: '¥ 1,802,500'
      },
      // {
      //   id: 18,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: true,
      //   type: ['B'],
      //   grade: ['Eco'],
      //   size: ['1618'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: false,
      //   thumbnail: '/images/b_eco_1618.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'アストラブラウン',
      //   wallColor: 'マローネウッド',
      //   surroundingWall: 'ミハスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気暖房乾燥機BS261H-CX-SH(200V)除菌',
      //   doorType: 'ＢＭ開戸',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'スマートスクエア浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアベージュ',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ファインホワイト',
      //   waterPanel: 'KF3070 壁付タッチ水栓',
      //   showerType: '3Wayワンストップeシャワー（メタル）',
      //   storageType: 'ワイドミラー',
      //   mirrorType: 'ワイドミラー',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,471,500',
      //   optionPrice: '¥ 303,000',
      //   totalPrice: '¥ 1,774,500'
      // },
      // {
      //   id: 19,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: true,
      //   type: ['B'],
      //   grade: ['Eco'],
      //   size: ['1620'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: false,
      //   thumbnail: '/images/b_eco_1620.jpg',
      //   thumbnailSize: false,
      //   recommendImageWide: '',
      //   recommendImageMin: '',
      //   floorColor: 'アストラブラウン',
      //   wallColor: 'マローネウッド',
      //   surroundingWall: 'ミハスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気暖房乾燥機BS261H-CX-SH(200V)除菌',
      //   doorType: 'ＢＭ開戸',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'スマートスクエア浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアベージュ',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ファインホワイト',
      //   waterPanel: 'KF3070 壁付タッチ水栓',
      //   showerType: '3Wayワンストップeシャワー（メタル）',
      //   storageType: 'ワイドミラー',
      //   mirrorType: 'ワイドミラー',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,571,500',
      //   optionPrice: '¥ 303,000',
      //   totalPrice: '¥ 1,874,500'
      // },
      {
        id: 20,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['Standard'],
        size: ['1216'],
        gradeType: 'Standard',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/b_standard_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドホワイト',
        wallColor: 'ソルティオニックス',
        surroundingWall: 'ソルティオニックス',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'アークスクエア浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアグラス',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF850 壁付水栓(サーモ)',
        showerType: 'ワンストップeシャワー（メタル）',
        storageType: 'ワイドミラー＋LED間接照明',
        mirrorType: 'ワイドミラー',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicPrice: '¥ 1,249,000',
        optionPrice: '¥ 60,000',
        totalPrice: '¥ 1,309,000'
      },
      {
        id: 28,
        recommendIndex: 50,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['Standard'],
        size: ['1317', '1416', '1418'],
        gradeType: 'Standard',
        noteDetachedOrComplex: '＊価格はマンション仕様',
        thumbnail: '/images/b_standard_1416.jpg',
        thumbnailSize: '1416',
        recommendImageWide: '/images/recommend_21.jpg',
        recommendImageMin: '/images/recommend_tb_21.jpg',
        floorColor: 'サンドベージュ',
        wallColor: 'カルドウッド',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'カルドウッド',
        ventilation: '換気暖房乾燥機',
        doorType: '折戸',
        doorMaterial: 'トウメイ',
        bathtubShape: 'スマートエッグ浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアベージュ',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'サーモスタット混合水栓（KF850）',
        showerType: 'ワンストップeシャワー（メタル）',
        storageType: 'ワイドミラー',
        mirrorType: 'ワイドミラー',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '無',
        basicSize: '1317',
        basicPrice: '¥ 1,487,000',
        optionPrice: '¥ 118,500',
        totalPrice: '¥ 1,605,500',
        anotherSize: '1416',
        anotherBasicPrice: '¥ 1,465,000',
        anotherOptionPrice: '¥ 118,500',
        anotherTotalPrice: '¥ 1,583,500',
        anotherSize2: '1418',
        anotherBasicPrice2: '¥ 1,512,000',
        anotherOptionPrice2: '¥ 118,500',
        anotherTotalPrice2: '¥ 1,630,500'
      },
      {
        id: 21,
        recommendIndex: 50,
        modal: false,
        recommend: true,
        hasPackage: false,
        type: ['B'],
        grade: ['Standard'],
        size: ['1616', '1618', '1620'],
        gradeType: 'Standard',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/b_standard_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '/images/recommend_21.jpg',
        recommendImageMin: '/images/recommend_tb_21.jpg',
        floorColor: 'アストラブラック',
        wallColor: 'ブロッコブラック',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: 'ＢＭ全幅片引戸',
        doorMaterial: 'トウメイ',
        bathtubShape: 'スマートスクエア浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ブラック',
        waterPanel: 'KF850 壁付水栓(サーモ)',
        showerType: 'ワンストップeシャワー（メタル）',
        storageType: 'ワイドミラー＋LED間接照明',
        mirrorType: 'ワイドミラー＋LED間接照明',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'ワイヤーラック2段',
        bathtubLid: '巻きフタ',
        frame: '窓額縁D200 1300x1000 OW',
        other: 'お掃除収納',
        basicSize: '1616',
        basicPrice: '¥ 1,319,000',
        optionPrice: '¥ 703,500',
        totalPrice: '¥ 2,022,500',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,451,000',
        anotherOptionPrice: '¥ 703,500',
        anotherTotalPrice: '¥ 2,154,500',
        anotherSize2: '1620',
        anotherBasicPrice2: '¥ 1,551,000',
        anotherOptionPrice2: '¥ 703,500',
        anotherTotalPrice2: '¥ 2,254,500'
      },
      // {
      //   id: 22,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: false,
      //   type: ['B'],
      //   grade: ['Standard'],
      //   size: ['1618'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: '*価格は戸建仕様',
      //   thumbnail: '/images/b_standard_1618.jpg',
      //   thumbnailSize: false,
      //   floorColor: 'アストラブラック',
      //   wallColor: 'ブロッコブラック',
      //   surroundingWall: 'グロスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-17',
      //   doorType: 'ＢＭ全幅片引戸',
      //   doorMaterial: 'トウメイ',
      //   bathtubShape: 'スマートスクエア浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアホワイト',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ブラック',
      //   waterPanel: 'KF850 壁付水栓(サーモ)',
      //   showerType: 'ワンストップeシャワー（メタル）',
      //   storageType: 'ワイドミラー＋LED間接照明',
      //   mirrorType: 'ワイドミラー＋LED間接照明',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'ワイヤーラック2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,220,000',
      //   optionPrice: '¥ 753,500',
      //   totalPrice: '¥ 1,973,500'
      // },
      // {
      //   id: 23,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: false,
      //   type: ['B'],
      //   grade: ['Standard'],
      //   size: ['1620'],
      //   gradeType: 'Standard',
      //   noteDetachedOrComplex: '*価格は戸建仕様',
      //   thumbnail: '/images/b_standard_1620.jpg',
      //   thumbnailSize: false,
      //   floorColor: 'アストラブラック',
      //   wallColor: 'ブロッコブラック',
      //   surroundingWall: 'グロスホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-17',
      //   doorType: 'ＢＭ全幅片引戸',
      //   doorMaterial: 'トウメイ',
      //   bathtubShape: 'スマートスクエア浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアホワイト',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ブラック',
      //   waterPanel: 'KF850 壁付水栓(サーモ)',
      //   showerType: 'ワンストップeシャワー（メタル）',
      //   storageType: 'ワイドミラー＋LED間接照明',
      //   mirrorType: 'ワイドミラー＋LED間接照明',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'ワイヤーラック2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,320,000',
      //   optionPrice: '¥ 753,500',
      //   totalPrice: '¥ 2,073,500'
      // },
      {
        id: 24,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['Simple'],
        size: ['1216'],
        gradeType: 'Simple',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/b_simple_1216.jpg',
        thumbnailSize: false,
        floorColor: 'サンドホワイト',
        wallColor: 'キュービーアクア',
        surroundingWall: 'グロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'アークスクエア浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓(サーモ)',
        showerType: 'ワンストップeシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: 'トールミラー（300×900）',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: 'お掃除収納',
        basicPrice: '¥ 1,089,000',
        optionPrice: '¥ 98,000',
        totalPrice: '¥ 1,187,000'
      },
      {
        id: 29,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['Simple'],
        size: ['1317', '1416', '1418'],
        gradeType: 'Simple',
        noteDetachedOrComplex: '＊ 価格はマンション仕様',
        thumbnail: '/images/b_simple_1317.jpg',
        thumbnailSize: '1317',
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドホワイト',
        wallColor: 'キュービーアクア',
        surroundingWall: 'クロスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'スマートエッグ浴槽',
        bathtubMaterial: 'FRP浴槽',
        bathtubColor: 'ファインホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓(サーモ)',
        showerType: 'ワンストップeシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: 'トールミラー（300x900）',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けG',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '無',
        basicSize: '1317',
        basicPrice: '¥ 1,303,000',
        optionPrice: '¥ 0',
        totalPrice: '¥ 1,303,000',
        anotherSize: '1416',
        anotherBasicPrice: '¥ 1,281,000',
        anotherOptionPrice: '¥ 0',
        anotherTotalPrice: '¥ 1,281,000',
        anotherSize2: '1418',
        anotherBasicPrice2: '¥ 1,336,000',
        anotherOptionPrice2: '¥ 0',
        anotherTotalPrice2: '¥ 1,336,000'
      },
      {
        id: 25,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['Simple'],
        size: ['1616', '1618', '1620'],
        gradeType: 'Simple',
        noteDetachedOrComplex: '*価格は戸建仕様',
        thumbnail: '/images/b_simple_1616.jpg',
        thumbnailSize: '1616',
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'サンドベージュ',
        wallColor: 'キュービーホワイト',
        surroundingWall: 'キュービーホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気扇FY-17',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'スマートスクエア浴槽',
        bathtubMaterial: 'メタリア人大浴槽',
        bathtubColor: 'メタリアピンク',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓(サーモ)',
        showerType: 'ワンストップeシャワー（メタル）',
        storageType: 'スクエアミラー',
        mirrorType: 'トールミラー（300×900）',
        lightingType: 'ダウンライト照明 LED 2灯 温白色',
        handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けＧ350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '巻きフタ',
        frame: '窓額縁D200 1300x1000 OW',
        other: '',
        basicSize: '1616',
        basicPrice: '¥ 1,159,000',
        optionPrice: '¥ 110,000',
        totalPrice: '¥ 1,269,000',
        anotherSize: '1618',
        anotherBasicPrice: '¥ 1,291,000',
        anotherOptionPrice: '¥ 110,000',
        anotherTotalPrice: '¥ 1,401,000',
        anotherSize2: '1620',
        anotherBasicPrice2: '¥ 1,391,000',
        anotherOptionPrice2: '¥ 110,000',
        anotherTotalPrice2: '¥ 1,501,000'
      },
      // {
      //   id: 26,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: false,
      //   type: ['B'],
      //   grade: ['Simple'],
      //   size: ['1618'],
      //   gradeType: 'Simple',
      //   noteDetachedOrComplex: '*価格は戸建仕様',
      //   thumbnail: '/images/b_simple_1618.jpg',
      //   thumbnailSize: false,
      //   floorColor: 'サンドベージュ',
      //   wallColor: 'キュービーホワイト',
      //   surroundingWall: 'キュービーホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-24',
      //   doorType: '折戸',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'スマートスクエア浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアピンク',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ホワイト',
      //   waterPanel: 'KF800&nbsp;壁付水栓(サーモ)',
      //   showerType: 'ワンストップeシャワー（メタル）',
      //   storageType: 'スクエアミラー',
      //   mirrorType: '鏡300x900',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,060,000',
      //   optionPrice: '¥ 128,000',
      //   totalPrice: '¥ 1,188,000'
      // },
      // {
      //   id: 27,
      //   recommendIndex: 0,
      //   modal: false,
      //   recommend: false,
      //   hasPackage: false,
      //   type: ['B'],
      //   grade: ['Simple'],
      //   size: ['1620'],
      //   gradeType: 'Simple',
      //   noteDetachedOrComplex: '*価格は戸建仕様',
      //   thumbnail: '/images/b_simple_1620.jpg',
      //   thumbnailSize: false
      //   floorColor: 'サンドベージュ',
      //   wallColor: 'キュービーホワイト',
      //   surroundingWall: 'キュービーホワイト',
      //   ceilingColor: 'ホワイト',
      //   ventilation: '換気扇FY-24',
      //   doorType: '折戸',
      //   doorMaterial: 'カスミ',
      //   bathtubShape: 'スマートスクエア浴槽',
      //   bathtubMaterial: 'メタリア人大浴槽',
      //   bathtubColor: 'メタリアピンク',
      //   drainageType: 'ポップアップ排水栓',
      //   heatRetention: '高断熱浴槽',
      //   apronColor: 'ファインホワイト',
      //   counterColor: 'ホワイト',
      //   waterPanel: 'KF800&nbsp;壁付水栓(サーモ)',
      //   showerType: 'ワンストップeシャワー（メタル）',
      //   storageType: 'スクエアミラー',
      //   mirrorType: '鏡300x900',
      //   lightingType: 'ダウンライト照明 LED 2灯 温白色',
      //   handrail: 'エスコート手摺Ⅱ(スライドフック3ヶ付)',
      //   sideHandrail: '無',
      //   doorHandrail: '無',
      //   towel: 'タオル掛けＧ350',
      //   rackType: 'クリアオープン棚W180メッキ2段',
      //   bathtubLid: '保温組蓋(フック3ヶ付)',
      //   frame: '窓額縁D200 1300x1000 OW',
      //   other: 'お掃除収納',
      //   basicPrice: '¥ 1,160,000',
      //   optionPrice: '¥ 128,000',
      //   totalPrice: '¥ 1,288,000'
      // },

      {
        id: 30,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['light'],
        size: ['1216'],
        gradeType: 'light',
        noteDetachedOrComplex: '* 価格はマンション仕様',
        thumbnail: '/images/b_light_1216.jpg',
        thumbnailSize: false,
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'アッシュホワイト',
        wallColor: 'プリュイピンク',
        surroundingWall: 'ミハスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気暖房乾燥機',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'アークスクエア浴槽',
        bathtubMaterial: 'FRP浴槽',
        bathtubColor: 'ファインホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓(サーモ)',
        showerType: 'eシャワー（メタル）',
        storageType: 'トールミラー（300x900）',
        mirrorType: 'トールミラー（300x900）',
        lightingType: 'ダウンライト照明 LED 1灯 温白色',
        handrail: 'SUS手摺L1000(スライドフック付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けG350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '無',
        basicSize: '1216',
        basicPrice: '¥ 1,085,000',
        optionPrice: '¥ 0',
        totalPrice: '¥ 1,085,000',
      },
      {
        id: 31,
        recommendIndex: 0,
        modal: false,
        recommend: false,
        hasPackage: false,
        type: ['B'],
        grade: ['light'],
        size: ['1317', '1416', '1418'],
        gradeType: 'light',
        noteDetachedOrComplex: '* 価格はマンション仕様',
        thumbnail: '/images/b_light_1317.jpg',
        thumbnailSize: '1317',
        recommendImageWide: '',
        recommendImageMin: '',
        floorColor: 'ミディアムベージュ',
        wallColor: 'ノワイエブラウン',
        surroundingWall: 'ミハスホワイト',
        ceilingColor: 'ホワイト',
        ventilation: '換気暖房乾燥機',
        doorType: '折戸',
        doorMaterial: 'カスミ',
        bathtubShape: 'スマートエッグ浴槽',
        bathtubMaterial: 'FRP浴槽',
        bathtubColor: 'ファインホワイト',
        drainageType: 'ポップアップ排水栓',
        heatRetention: '高断熱浴槽',
        apronColor: 'ファインホワイト',
        counterColor: 'ホワイト',
        waterPanel: 'KF800　壁付水栓(サーモ)',
        showerType: 'eシャワー（メタル）',
        storageType: 'トールミラー（300x900）',
        mirrorType: 'トールミラー（300x900）',
        lightingType: 'ダウンライト照明 LED 1灯 温白色',
        handrail: 'SUS手摺L1000(スライドフック付)',
        sideHandrail: '無',
        doorHandrail: '無',
        towel: 'タオル掛けG350',
        rackType: 'クリアオープン棚W180メッキ2段',
        bathtubLid: '保温組蓋(フック3ヶ付)',
        frame: '窓額縁D200 1300x1000 OW',
        other: '無',
        basicSize: '1317',
        basicPrice: '¥ 1,229,400',
        optionPrice: '¥ 0',
        totalPrice: '¥ 1,229,400',
        anotherSize: '1416',
        anotherBasicPrice: '¥ 1,207,400',
        anotherOptionPrice: '¥ 0',
        anotherTotalPrice: '¥ 1,207,400',
        anotherSize2: '1418',
        anotherBasicPrice2: '¥ 1,260,000 ',
        anotherOptionPrice2: '¥ 0',
        anotherTotalPrice2: '¥ 1,260,000'
      },
    ]
  },
  mutations: {
    toggleHeaderMenu (state) {
      state.menu = !state.menu
    },
    updateCurrentSection (state, getValue) {
      state.currentSection = getValue;
    }
  },
  actions: {
    toggleHeaderMenu ({ commit }) {
      commit('toggleHeaderMenu')
    }
  }
})
